import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Document } from 'jsonapi-typescript';
import { map, Observable } from 'rxjs';
import { SupportRequestPayload } from '../interfaces/support-request-payload.interface';
import { serializeSupportRequest } from '../serializers/support-request.serializer';
import { ENVIRONMENT } from '../tokens/environment.token';
import { PROPAGATE_HTTP_ERRORS } from '../tokens/propagate-http-errors.token';

@Injectable({ providedIn: 'root' })
export class SupportRequestsApiService {
	private httpClient = inject(HttpClient);
	private environment = inject(ENVIRONMENT);

	create(supportRequest: SupportRequestPayload): Observable<void> {
		return this.httpClient
			.post<Document>(
				this.environment.serverNew + '/user/v1/support-requests',
				serializeSupportRequest(supportRequest),
				{ context: new HttpContext().set(PROPAGATE_HTTP_ERRORS, true) }
			)
			.pipe(map(() => undefined));
	}
}
